module.exports = __webpack_public_path__ + "img/qi.0bfbde2b.png";